import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

import { StrutturaVO } from "@vo/strutturaVO";
import { StrutturaDTO } from "@dto/strutturaDTO";

@Injectable({
  providedIn: "root"
})
export class MapperStruttura
  implements MapperInterface<StrutturaDTO, StrutturaVO> {
  convertVoToDto(e: StrutturaVO): StrutturaDTO {
    const strutturaDTO = new StrutturaDTO();
    //strutturaDTO.idCmu = e.id;
    strutturaDTO.nomeCmu = e.nome;
    strutturaDTO.responsabileCmu = e.responsabile;
    return strutturaDTO || new StrutturaDTO();
  }
  convertDtoToVo(t: StrutturaDTO): StrutturaVO {
    const strutturaVO = new StrutturaVO();
    strutturaVO.id = t.idCmu;
    strutturaVO.nome = t.nomeCmu;
    strutturaVO.responsabile = t.responsabileCmu;
    return strutturaVO || new StrutturaVO();
  }
  convertListVoToDto(e: StrutturaVO[]): StrutturaDTO[] {
    const strutturaDTOList = new Array<StrutturaDTO>();
    if (e != null && e.length > 0) {
      e.forEach(strutturaVO => {
        strutturaDTOList.push(this.convertVoToDto(strutturaVO));
      });
    }
    return strutturaDTOList || new Array<StrutturaDTO>();
  }

  convertListDtoToVo(t: StrutturaDTO[]): StrutturaVO[] {
    // console.log("[MapperStruttura] StrutturaDTOList => StrutturaVOList");
    const strutturaVOList = new Array<StrutturaVO>();
    if (t != null && t.length > 0) {
      t.forEach(strutturaDTO => {
        strutturaVOList.push(this.convertDtoToVo(strutturaDTO));
      });
    }
    return strutturaVOList || new Array<StrutturaVO>();
  }
}
